<script lang="ts">
	import { NewsSearchSuggestions } from './NewsSearchSuggestions';
	import type { SearchCombobox } from '$global/features/search/utils/createSearchCombobox';

	interface Props {
		combobox?: SearchCombobox | undefined;
		onCloseSearch?: (() => void) | undefined;
		forceShowGlobalNav?: boolean | undefined;
	}

	let {
		combobox = undefined,
		onCloseSearch = undefined,
		forceShowGlobalNav = undefined,
	}: Props = $props();
</script>

<NewsSearchSuggestions {combobox} {onCloseSearch} {forceShowGlobalNav} />
